export default __webpack_public_path__ + "static/media/cama.da7f97cc.png";